import React, {useEffect, useState}from 'react'
import ProductAction from 'actions/Product';
import PropTypes from 'prop-types';
import ShelfTogether from 'components/Product/ShopTogether/ShelfTogether';
import Price from 'components/Price';
import PromotionFactory from 'factories/Promotion';
import PubSub from 'services/PubSub';
import Loader from 'components/Loader';
import CartAction from "actions/Cart";
import { actionsType, ecommerce } from 'config/constants';
import SalesChannel from 'services/SalesChannel';
import { shopTogetherFlag } from 'config';
import {useViewportMediaQuery} from 'hooks';
import IconCencosudCard from 'components/IconCencosudCard';
import TagManagerService from 'services/TagManager';
import style from './style.scss'//NOSONAR

let actions = [];
let _productsChecked = {}
const ShopTogether = (props) => {
    if(!shopTogetherFlag) return ''

    const { skuId, currentProd, viewAll, allProducts, campaignData, categoryIds } = props;

    const isMobile = useViewportMediaQuery(741);

    const [products, setProducts] = useState([])
    const [currentProduct, setCurrentProduct] = useState({})
    const [total, setTotal] = useState(0);
    const [totalTcenco, setTotalTcenco] = useState(0);
    const [productsChecked, setProductsChecked] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const _setFilterValue = (property, propertyName) => {
        let propertyValue = '';
        if(categoryIds && categoryIds.length){
            if(property === 'department'){
                propertyValue = categoryIds[0].split('/').filter(Boolean)[0];
            }
            if(property === 'category'){
                propertyValue = categoryIds[0].split('/').filter(Boolean)[1];
            }
            if(property === 'subcategory'){
                propertyValue = categoryIds[0].split('/').filter(Boolean)[2] ? categoryIds[0].split('/').filter(Boolean)[2] : categoryIds[0].split('/').filter(Boolean)[1]
            }
            return '&filterValues=' + propertyName +':'+propertyValue;
        }
        return '';
    }
    const _getFilterValues = (_data) => {
        let filterValues = '';
        if(_data && _data.filters_values){
            _data.filters_values.forEach((_filter) => {
                const propertyName = _filter.property_name ? _filter.property_name.replace('$','') : '';
                if(_filter.property_filter === 'other' && _filter.property_value){
                    filterValues += '&filterValues=' + propertyName + ':' + _filter.property_value
                } else {
                    filterValues += _setFilterValue(_filter.property_filter, propertyName)
                }
            })
        }
        if(_data.property_name && !filterValues){
            filterValues = _setFilterValue(_data.property_name, _data.property_name)
        }
        return filterValues
    }

    useEffect(() => {
        actions.push(PubSub.register('checkbox-products-together', checkProducts))

        if(!(allProducts && allProducts.currentProduct) && skuId && campaignData){
            const filterValues = _getFilterValues(campaignData);
            ProductAction.getRecommended(4, skuId, campaignData && campaignData.campaign, campaignData && campaignData.filter, undefined, undefined, filterValues).then((results)=> {
                if(results && results.length){
                    let _prods = results.filter(item => validStock(item)).slice(0, 2);
                    _prods = _prods.map((items, i) => {
                        const _item = items.items[0] || items.item;
                        const gtmData = {
                            'name': _item.name,
                            'id': _item.itemId,
                            'refId': _item.referenceId[0].Value,
                            'price': _item.prices.regular,
                            'brand': items.brand,
                            'category': items.categories && items.categories[0] || '',
                            'variant': '',
                            'list': 'Compra Juntos',
                            'position': (_item.pos || _item.pos === 0) ? _item.pos : i + 1,
                            'type': 'impression-plp'
                        };
                        items.gtmData = gtmData;
                        return items
                    })


                    setProducts(_prods);
                } 
                else setProducts([])
            })

        }


        return function cleanup(){
            actions.map(token => PubSub.unregister(token));
            actions = [];
            _productsChecked = {};
        }
    },[skuId, campaignData])

    useEffect(() => {
        if(isMobile !== null && !isMobile){
            _closeModal();
        }
    },[isMobile])

    useEffect(() => {
        if(currentProd){
            const _item = currentProd.items[0] || currentProd.item;
            const gtmData = {
                'name': _item.productName,
                'id': _item.itemId,
                'refId': _item.referenceId[0].Value,
                'price': _item.prices.regular,
                'brand': _item.brand,
                'category': _item.categories && _item.categories[0] || '',
                'variant': '',
                'list': 'Compra Juntos',
                'position': (_item.pos || _item.pos === 0) ? _item.pos : 0,
                'type': 'impression-plp'
            };
            currentProd.gtmData = gtmData;

            setCurrentProduct(currentProd)
        }
    },[currentProd])

    useEffect(() => {
        if(allProducts && allProducts.currentProduct){
            setCurrentProduct(allProducts.currentProduct);
            setProducts(allProducts.products)
        }
    },[allProducts])

    useEffect(() => {
        if(!(products && products.length)) return '';
        let _totalTcenco = 0;
        let _total = 0;
        products.forEach(product => {
            if(productsChecked[parseInt(product.items[0].itemId)]){
                const totals = _getTotals(product);
                
                _total += totals.total;
                _totalTcenco += totals.totalTcenco ? totals.totalTcenco : totals.total;
            }
        });
        
        const totals = _getTotals(currentProduct);
        _total += totals.total;
        _totalTcenco += totals.totalTcenco ? totals.totalTcenco : totals.total;
        setTotal(_total);
        setTotalTcenco(_totalTcenco);
        
    },[productsChecked])

    const checkProducts = (payload) => {
        if(payload.value){
            _productsChecked = {..._productsChecked}
            _productsChecked[payload.value.skuId] = payload.value.value;
            setProductsChecked({..._productsChecked});
        }
    }

    const addToCart = () => {   
        if(isLoading) return false;
        let gtmProducts = [];
        let prods = Object.keys(productsChecked).map((item) => {
            if(productsChecked[item]){
                const prod = products.filter(_prod => _prod.items[0].itemId == item)

                if(!(prod && prod.length)) return false;

                const _item = prod[0].items[0];
                if(_item.inCart && (_item.maxItems <= _item.inCart)) return false;

                gtmProducts = gtmProducts.concat(prod);
                return {
                    id: item,
                    quantity: _item.inCart  ? prod[0].items[0].inCart + 1 : 1,
                    seller: '1'
                }
            }
            return false
        }).filter(Boolean)

        setIsLoading(true);
        const _item = currentProduct.items[0];
        if(!(_item.maxItems <= _item.inCart)){
            gtmProducts.push(currentProduct);
            prods.push({
                id: _item.itemId,
                quantity: (currentProduct.items && _item.inCart) ? _item.inCart + 1 : 1,
                seller: ecommerce.whiteLabel ? SalesChannel.getSeller() : '1'
            })
        }
        
        if(prods && prods.length){

            CartAction.addItems(prods).then(() => {
                gtmProducts.forEach((product, index) => {
                    TagManagerService.productClick(product, "Compra Juntos", index);
                    TagManagerService.addToCart(product, 1, "Compra Juntos");
                })
                
                TagManager(currentProduct.productName, gtmProducts);

                setIsLoading(false)
                setTimeout(() => {
                    PubSub.dispatch('open_snackbar',{
                        titleButtonMobile: '',
                        titleButtonDesktop: '',
                        TitleMobile: '¡Productos agregados al carro!',
                        TitleDesktop: `¡Productos agregados al carro!`,
                        Subtitle: 'Revisa tu carro de compras',
                        timer: 10000,
                        type: 'addToCart'
                    });
                },0);
                setTimeout(() => {
                    _closeModal()
                } , 1500);
            });
        }
    }

    const TagManager = (currentProd, gtmProducts) => {
        let sku = '';

        gtmProducts.map((prod) => {
            sku = sku + (sku ? '/' : '') + prod.item.itemId
        });

        TagManagerService.shopTogether('Agregar al carro - Compra juntos', currentProd, sku)
    }

    const validStock = (product) => {
        const _items = product.items && product.items.length ? product.items : null;
        const _seller = _items && _items[0].sellers && _items[0].sellers.length ? _items[0].sellers[0] : null;
        return !!(_seller && _seller.commertialOffer.AvailableQuantity > 0 && _seller.commertialOffer.ListPrice > 0)
    }

    
    const _getTotals = (product) => {
        let _totalTcenco = 0;
        let _total = 0;
        const pricesPromotions = PromotionFactory.getPromotionsApplied(product);
        const subTotal = pricesPromotions.filter(promo => promo.price && !promo.tcenco && promo.type !== "for_the_price_of");
        const subTotalTcenco = pricesPromotions.filter(promo => promo.price && promo.tcenco && promo.type !== "for_the_price_of");
        if(subTotal && subTotal.length) _total = subTotal[0].price;
        if(subTotalTcenco && subTotalTcenco.length) _totalTcenco = subTotalTcenco[0].price;
        return {totalTcenco: _totalTcenco, total:_total}
    }
    
    const _openModal = () => {
        PubSub.dispatch(actionsType.MODAL.SHOP_TOGETHER_OPEN, {currentProduct, products})
    }
    const _closeModal = () => {
        PubSub.dispatch(actionsType.MODAL.SHOP_TOGETHER_CLOSE);
    }
    if(!(products && products.length && currentProduct)) return '';
    
    return (
        <div className={"shop-together" + (viewAll ? ' new-modal-container view-all' : '')}>
            <div className={"shop-together-wrapper" + (viewAll ? ' new-modal-scroll' : '')}>

                <div className={"shop-together-content left" + ((products && products.length === 1) ? ' single-product' : '')}>
                    <span className={"title-wrapper-main" + (viewAll ? ' mobile-version': '')}>Estás viendo</span>

                    <div className="shop-together-products left">
                        <ShelfTogether product={currentProduct} mobileVersion={!viewAll} listTitle={'Compra Juntos'} gtmData={currentProduct.gtmData}/> 
                        <span className="plus-together"> 
                            <span className="plus-together-item jumbo-icon-new-plus"></span>
                        </span>
                    </div>
                </div>

                <div className={"shop-together-content right" + ((products && products.length === 1) ? ' single-product' : '')}>
                    <span className="title-wrapper-main">Llévalos juntos</span>

                    <div className="shop-together-products right">
                        {products.map((item, i) => {
                            if(!(item.items && item.items.length)) return false
                            return (<React.Fragment key={i}>
                                <ShelfTogether product={item} withCheckbox={true} mobileVersion={!viewAll} listTitle={'Compra Juntos'} gtmData={item.gtmData}/>
                                {(i !== products.length - 1) ? <span className="plus-together"> 
                                    <span className="plus-together-item jumbo-icon-new-plus"></span>
                                </span> : ''}
                            </React.Fragment>)
                        })}
                    </div>
                </div>
            </div>

            <div className={"container-actions" + (viewAll ? ' modal-actions' : '')}>
                <span className="container-actions-prices">
                    <span className="title-actions">Total </span>
                    <span className="prices-actions">
                        {!!totalTcenco && (totalTcenco < total) && <span className="mount-actions-tcenco"><Price price={totalTcenco}/><IconCencosudCard className='tcenco-logo-together' /></span>}
                        <span className="mount-actions"><Price price={total}/></span>
                    </span>
                </span>
                <button onClick={_openModal} className="button-mobile-open jumbo-icon-arrow" />
                
                <div className="container-actions-buttons">
                    {viewAll && <button className="secundary-btn modal-shop-together-btn" onClick={_closeModal}>
                        Volver
                    </button>}

                    <button className="primary-btn button-shop-together" onClick={addToCart}>
                        {isLoading && <div className="loader-shop-together"><Loader /></div>}
                        {!isLoading && 'Agregar'}
                    </button>
                </div>
            </div>
        </div>
    )
}

ShopTogether.propTypes = {
    skuId: PropTypes.string,
    currentProd: PropTypes.object, 
    viewAll: PropTypes.bool,
    allProducts: PropTypes.object,
    campaignData: PropTypes.object
}

export default ShopTogether
